export default class TicketTemplatesListController {
    constructor($scope, $injector) {
        this.scope = $scope;
        this.injector = $injector;

        this.store = this.injector.get('TicketTemplates');

        this._initStore();
    }

    _initStore() {
        this.store.dispatch('loadWorkflows', 'tickets::templates-list');
        this.store.commit('setVm', this);
    }

    goToDetails({action, row}, store) {
        this.injector.get('$state').go('app.tickets.templates.edit', {id: row.id});
    }
}

TicketTemplatesListController.$inject = [
    '$scope',
    '$injector'
];



// WEBPACK FOOTER //
// ./src/app/modules/tickets/templates/controllers/pages/list-controller.js